import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Brain, Leaf, Zap } from "lucide-react";

const principles = [
{ icon: Brain, label: "Nervous system first", sub: "Gentle signals, not shock therapy." },
{ icon: Leaf, label: "Food first, always", sub: "Real snacks, not supplements in disguise." },
{ icon: Zap, label: "Consistency over intensity", sub: "Steady shifts, no crash-and-burn." }];


const BrandManifesto = () => {
  const { ref, isVisible } = useScrollAnimation();

  return null;
};

export default BrandManifesto;